import React from 'react';

// Hero block — owns the page's single <h1>. Presentation only.
export default function Hero({ title, kicker, lead }) {
  return (
    <header className="mb-6">
      {kicker ? (
        <p className="mb-3 text-xs uppercase tracking-[0.2em] text-neutral-500">{kicker}</p>
      ) : null}
      <h1 className="font-heading text-3xl md:text-4xl font-bold text-black tracking-tight">{title}</h1>
      {lead ? <p className="mt-4 max-w-2xl text-lg text-neutral-600">{lead}</p> : null}
    </header>
  );
}
